import graphqlClient from './client';
import gql from 'graphql-tag';

export const query = gql`
  query ProspectEmails($prospectId: ID!, $candidateId: ID!) {
    prospectEmails(prospectId: $prospectId, candidateId: $candidateId) {
      nodes {
        id
        subject
        message
        sentDate
        from
        to
        candidateId
        prospectId
      }
    }
  }
`;

const fetchProspectEmails = async (prospectId: string, candidateId: string) => {
  const { data } = await graphqlClient.query({
    variables: { prospectId, candidateId },
    query,
  });
  if (data === null) {
    throw new Error('error in rendering emails');
  }
  const emails = data.prospectEmails.nodes
    .map((email: Record<string, any>) => ({
      id: email.id,
      subject: email.subject,
      message: email.message,
      sentDate: email.sentDate,
      from: email.from,
      to: email.to,
      candidateId: email.candidateId,
      prospectId: email.prospectId,
    }))
    .sort((email1: Record<string, any>, email2: Record<string, any>) =>
      (email2.sentDate as string).localeCompare(email1.sentDate as string),
    );

  return emails;
};

export default fetchProspectEmails;
